import { Component, OnInit, effect, inject } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { AuthService } from '../../services/auth.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { SessionVariable } from '../../enum/session-variable';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedSignalsService } from '../../services/shared-signals.service';

@Component({
  selector: 'taly-user-idle',
  templateUrl: './user-idle.component.html',
  styleUrls: ['./user-idle.component.scss']
})
export class UserIdleComponent implements OnInit {

  trasferSignal = inject(SharedSignalsService)

  timer: number = 0;
  
  constructor( private confirmationService: ConfirmationService, public authService : AuthService, public storageService : LocalStorageService, private router: Router, private activatedRoute: ActivatedRoute,){
    effect(() => {
      const showPopup : boolean = this.trasferSignal?.showTimeOutPopup();
      if(showPopup){
        this.confirmDialog();
      }
      this.timer = this.trasferSignal.sessionTimer();
    });
  }
  ngOnInit(): void {    
  }
  confirmDialog() {
    this.confirmationService.confirm({
      message: this.timer == 0 ? 'Your session has expired.' : ` Your session is expire in ${ this.timer } second( s).`,
      defaultFocus:'none',
      acceptIcon:'none',
      rejectIcon:'none',       
      accept: () => {
        this.trasferSignal.setTimeOutPopup(false);
        //Create Function for call refresh token api
        this.refrestToken()       
      },
      reject: (type) => {
        this.trasferSignal.setTimeOutPopup(false);
        this.router.navigate(['/'], { relativeTo: this.activatedRoute });
      }
    });

  }

  refrestToken(){
    this.authService.refreshToken().subscribe(resp => {
      this.storageService.setItem(SessionVariable.ACESS_TOKEN, resp?.access_token);
      this.storageService.setItem(SessionVariable.REFRESHT_TOKEN_KEY, resp?.refresh_token);
    }, err => {
     this.authService.showMessage('error', err);
    })
  }



}
